export const MENTION_SEARCH = {
  TRIGGERS: {
    USER: '@',
    HASHTAG: '#'
  },
  KEYS: {
    USER_ID: 'gsi4pk',
    WLS_USER_ID: 'user_id',
    USER_LABEL: 'user_name',
    DISPLAY_NAME: 'publicly_displayed_name',
    HASHTAG_LABEL: 'tag_name'
  },
  TIMING: {
    /* Lets the mention panel state settle before a keystroke is evaluated */
    INPUT_SETTLE_MS: 60,
    /* Only the network call is debounced, cached matches render instantly */
    REQUEST_DEBOUNCE_MS: 250,
    CACHE_TTL_MS: 60000
  },
  LIMITS: {
    CACHE_ENTRIES: 40,
    /* Mentions allow spaces, so a query is capped to a first and last name */
    QUERY_WORDS: 2,
    PAGE_SIZE: 10,
    PAGE: 1,
    MAX_ITEMS: 30
  },
  TOKENS: {
    EMPTY: '',
    SPACE: ' ',
    LINE_BREAK: '\n'
  }
} as const;
